export const getMicPermissions = () => navigator.mediaDevices.getUserMedia({ audio: true });
